import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import ButtonSmily from "@Components/atoms/ButtonSmily";
import { useBreakpoint } from "@Hooks/useBreakpoint";
import { ReactComponent as IconArrowRight } from "@Icons/16x16/arrow-right.svg";
import { Section, Tile } from "@Types/pagify";
import { getLink } from "@Utils/pagify";
import { HomeCategoriesItem } from "./HomeCategoriesItem";
import { HomeCategoriesItemMobile } from "./HomeCategoriesItemMobile";
import "./style.scss";

export const HomeCategories: FunctionComponent<{
  section: Section;
  tiles: Tile[];
}> = ({ section, tiles }) => {
  const intl = useIntl();
  const localeSlug = intl.locale;

  const { isMediumScreen } = useBreakpoint();

  const title = section.title;
  const subtitle = section.subtitle.map((textBlock) => {
    return textBlock.navigationLink?.link ? (
      <a
        className="HomeCategories-subtitle-link"
        href={getLink(textBlock.navigationLink, localeSlug)}
        key={textBlock.text}
      >
        {textBlock.text}
      </a>
    ) : (
      <span className="HomeCategories-subtitle-text" key={textBlock.text}>
        {textBlock.text}
      </span>
    );
  });

  const cta = section.cta[0];

  return (
    <div className="HomeCategories">
      <h2 className="HomeCategories-title">{title}</h2>
      <div className="HomeCategories-subtitle">{subtitle}</div>
      <div className="HomeCategories-list">
        {tiles.map((tile) =>
          isMediumScreen ? (
            <HomeCategoriesItemMobile key={tile.slug} tile={tile} />
          ) : (
            <HomeCategoriesItem key={tile.slug} tile={tile} />
          )
        )}
      </div>
      {!!cta && (
        <ButtonSmily
          href={getLink(cta.navigationLink, localeSlug)}
          icon={<IconArrowRight />}
          iconPosition="right"
          size="s"
          type="primary"
        >
          {cta.text}
        </ButtonSmily>
      )}
    </div>
  );
};
